import { render, staticRenderFns } from "./Golven.vue?vue&type=template&id=b8ea0b9e&"
import script from "./Golven.vue?vue&type=script&lang=js&"
export * from "./Golven.vue?vue&type=script&lang=js&"
import style0 from "./Golven.vue?vue&type=style&index=0&id=b8ea0b9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports